import { giphyDarkCharcoal, giphyIndigo, giphyLightGrey, giphyWhite } from '@giphy/js-brand'
import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import useDebounce from 'react-use/lib/useDebounce'

const SearchContainer = styled.div`
    height: 36px;
    margin: 10px 0;
`

const SearchButton = styled.div`
    background-color: ${giphyIndigo};
    color: ${giphyWhite};
    display: inline-block;
    height: 36px;
    width: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
`

const Input = styled.input<{ matches?: boolean }>`
    ${props =>
        props.matches &&
        css`
            font-weight: bold;
        `}
    display: inline-block;
    vertical-align: top;
    padding: 10px;
    font-size: 15px;
    border-radius: 0px;
    background-color: ${giphyDarkCharcoal};
    color: ${giphyWhite};
    outline: 0;
    border: 0;
    box-sizing: border-box;
    -webkit-appearance: none;
    &::placeholder {
        color: ${giphyLightGrey};
        font-size: 16px;
    }
    height: 36px;
    width: calc(100% - 36px);
`

const SEARCH_DEBOUNCE = 500

type SearchBarProps = {
    onChange?: (searchText: string) => void
    onFocus?: () => void
    value?: string
    matches?: boolean
    placeholder?: string
}
export const SearchBar = ({
    onChange,
    onFocus,
    value,
    matches,
    placeholder = 'Search Collections',
}: SearchBarProps) => {
    const [debouncedInput, setDebouncedInput] = useState<string>('')
    useDebounce(() => onChange?.(debouncedInput), SEARCH_DEBOUNCE, [debouncedInput])
    return (
        <SearchContainer>
            <Input
                matches={matches}
                onFocus={() => {
                    onFocus?.()
                }}
                placeholder={placeholder}
                onChange={({ target: { value } }) => setDebouncedInput(value)}
                value={value}
            />
            <SearchButton className="ss-search" />
        </SearchContainer>
    )
}
